import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { DashboardService } from 'src/app/rest_services/dashboard.service';
import { NewactionService } from 'src/app/rest_services/newaction.service';
import { UserService } from 'src/app/rest_services/user.service';
import { VisitService } from 'src/app/rest_services/visit.service';
import { history } from '../users/equipe/history';
import { actions } from '../new-visit/visite_data_static';
import { MsSectorService } from 'src/app/rest_services/ms-sector.service';
import { SettingsService } from 'src/app/rest_services/settings.service';
import { RoleService } from 'src/app/rest_services/role.service';
import { SurveyService } from 'src/app/rest_services/msSurveyServices/survey.service';
declare var NotificationFx:any;
declare var Snap:any;

@Component({
  selector: 'app-visite',
  templateUrl: './visite.component.html',
  styleUrls: ['./visite.component.css']
})
export class VisiteComponent implements OnInit, OnDestroy {
  user: any;
  token:any = '';
  APIToken:any = '';
  newactionRequest:any;
  modifyactionRequest:any;
  modifyactionForm: FormGroup;
  actionEdit:any={};
  actionsTeam:any[]=actions;
  htmlYouWantToAdd:any="";
  actionsSelected:any[]=[];
  newactionForm: FormGroup;
  historyActions: any[] = history;
  publicActions:any[]=[];
  customizedActions:any[]=[];

  visit:any;
  actions:any[] = [];
  perso:any;
  set:any;
  detailrapport:any={};
  visitdetail:any={};
  supprimeraction:any;
  allshowing: boolean=false;

  updateActionForm!: FormGroup;
  mobile:boolean=false;medium:boolean=false;

  showmore() {
    this.allshowing=true;
    this.today = this.contacted_persons;
  }
  showless(){
    this.today =this.today.slice(0, 0);
    this.allshowing=false;
  }

  constructor(
    private fb: FormBuilder, 
    private msSurvey : SurveyService,
    private userServiceService:UserService, 
    private roleService: RoleService,
    private settingsService:SettingsService,
    private msSector:MsSectorService, 
    private visitService:VisitService,
    private route: ActivatedRoute, 
    private newactionServiceService:NewactionService, 
    private modifyactionServiceService:NewactionService,
    private dashboardServiceservice:DashboardService
    ) {
    this.modifyactionForm = this.fb.group({
      'action_label': ['', Validators.required],
      // 'action_type' : ['', Validators.required] 
    });  
    this.newactionForm = this.fb.group({
      'action_label': ['', Validators.required],
      // 'action_type' : ['', Validators.required] 
    });
    
    this.updateActionForm = this.fb.group({
      description:['', [Validators.required]],
      status:['', [Validators.required]],
      motif:['', [Validators.required]]
    });

    this.actionEdit.action_type=1;
   }
  loading_tab_actions:boolean=true;loading_tab_details:boolean=true;loading_actions:boolean=true;
  role:any="";
  storedRoles:any;
  id:any;
  from:any;
  ngOnInit(): void {
    this.getConfig();
    this.getProfileRoles();
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    if(localStorage.getItem("role")!=undefined) {
      this.role = localStorage.getItem("role");
      this.APIToken = localStorage.getItem("token");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.role = sessionStorage.getItem("role");
      this.APIToken = sessionStorage.getItem("token");
    }

    if (window.screen.width <= 768) { // 768px portrait
      this.mobile = true;
      if (window.screen.width > 668) this.medium = true;
    }else {
      this.mobile = false;
    }
    const id= this.route.snapshot.paramMap.get('cr')

    this.getSurveyStatus(id);
    
    this.id= this.route.snapshot.paramMap.get('cr')
    var fr= window.location.href.split( 'from');
    if(fr[1]!=undefined && fr.length>0){
      var from = fr[1].split(';')[0];
      if(from=="comments"){
        (<any>$('.nav-pills a[href="#conversation"]')).tab('show');
        this.getMessagesVisitTerminated(this.id);
      } else if(from=="actions"){ 
        setTimeout(() => {
         (<any>$('.nav-pills a[href="#actions"]')).tab('show');
        }, 2000); 
      }
    }
    if(window.location.href.indexOf("customers") > -1){
      this.from = "customers";
    }

    $(document).ready(function() {
      (<any>$('#actions_ofvisit')).DataTable( {
          "pagingType": "full_numbers",
          "language": {
              "paginate": {
                "first": "<i class='flaticon-left-arrow'></i>",
                "previous": "<i class='flaticon-arrow-left-1'></i>",
                "next": "<i class='flaticon-arrow-right'></i>",
                "last": "<i class='flaticon-right-arrow'></i>",
              },
              "info": "Showing page _PAGE_ of _PAGES_"
          }
      });
    } );
    // this.getTabDetails();
    this.Detail(this.id);
    // this.getMessagesVisitTerminated(id);
    if(this.role =="cmrc"){
      this.TodayPlanning();
      //SHOW NOTIFICATION TO COMMERCIAL TO CREATE NEW VISITS
      var svgshape = document.getElementById( 'notification-corner-expand-shape' )as HTMLElement,
        s = Snap( svgshape?.querySelector( 'svg' ) ),
        path = s.select( 'path' ),
        pathConfig = {
            from : path?.attr( 'd' ),
            to : svgshape?.getAttribute( 'data-path-to' )
        }
        NotificationFx.prototype.options = {
          wrapper : document.body,
          message : 'yo!',
          layout : 'growl',
          effect : 'slide',
          type : 'error',
          ttl : 180000, //TIMEOUT CLOSE NOTIFICATIONS - BY ROU
          // callbacks
          onClose : function() { return false; },
          onOpen : function() { return false; }
        }
    }
  }

  config: any = {
    skypeVisibility: false,
    zipCodeVisibility: false
  };
  getConfig(){
    this.settingsService.getConfig().subscribe(
      (resp: any) => {
        if(resp.code == "45859d1ba9e878f62c51935e3119d7ad"){
          this.config.skypeVisibility = resp.config.skypeVisibility;
          this.config.zipCodeVisibility = resp.config.zipCodeVisibility;
          this.config.survey = resp.config.survey;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
  loading_survey_answers:boolean = true;
  getSurveyAnswers(){
    this.loading_survey_answers=true;
    const id= this.route.snapshot.paramMap.get('cr')
    const surveyContainer = document.getElementById('surveyQuestions');
    if(surveyContainer)surveyContainer.innerHTML = '';

    this.getCustomerResponses(id);
  }
  generateSurvey(survey_answers :any) {
    var surveyContainer = document.getElementById('surveyQuestions');
    var questionTypeOrder: { [key: string]: number } = { 'st': 1, 'ch': 2, 'fr': 3 };

    // Sort the survey answers based on the custom order
    survey_answers.sort(function (a: any, b: any) {
        return questionTypeOrder[a.qst_type] - questionTypeOrder[b.qst_type];
    });

    survey_answers.forEach(function (answer:any) {
      var questionDiv = document.createElement('div');
      questionDiv.className = "row d-flex justify-content-center mb-5 mt-5";
      var questionContent = `
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              ${answer.question}
          </div>
      `;
      var responseContent;
      if (answer.qst_type === 'ch') {
          responseContent = `
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="display: flex; justify-content: space-evenly">
                  <div>
                      <label class="new-control new-checkbox new-checkbox-rounded checkbox-success">
                          <input type="checkbox" disabled ${answer.response === 'oui' ? 'checked' : ''} class="new-control-input">
                          <span class="new-control-indicator"></span>Oui 
                      </label>
                  </div>
                  <div>
                      <label class="new-control new-checkbox new-checkbox-rounded checkbox-success">
                          <input type="checkbox" disabled ${answer.response === 'non' ? 'checked' : ''} class="new-control-input">
                          <span class="new-control-indicator"></span>Non 
                      </label>
                  </div>
              </div>
          `;
      } else if (answer.qst_type === 'st') {
          var filledStars = parseInt(answer.response);
          var emptyStars = 5 - filledStars;
          responseContent = `
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="display: block;">
                  <ul>
                      ${Array.from({ length: filledStars }, (_, i) => `
                          <li class="col-2 step-item-line mr-1 list-inline-item">
                              <i class="flaticon-star-fill"></i>
                          </li>
                      `).join('')}
                      ${Array.from({ length: emptyStars }, (_, i) => `
                          <li class="col-2 step-item-line mr-1 list-inline-item">
                              <i class="flaticon-star-outline"></i>
                          </li>
                      `).join('')}
                  </ul>
              </div>
          `;
        } else if (answer.qst_type === 'fr') {
          responseContent = `
              <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12" style="display: block;">
                  <textarea style="height: 120px;" readonly class="form-control pl-3 pr-3" rows="2">${answer.response}</textarea>
              </div>
          `;
      }
      questionDiv.innerHTML = questionContent + responseContent;
      surveyContainer?.appendChild(questionDiv);
    });
  }
  customer_fullName:string = '';

  getCustomerResponses(visitUuid: any){
    this.msSurvey.getCustomerResponses(visitUuid);
    this.msSurvey.customerResponsesSubject.subscribe(
      ( data: any ) => {
        if(data.status== '200'){
          const survey_answers = data.survey_answers;
          this.getCustomerRSByVisitUuid(visitUuid);
          this.generateSurvey(survey_answers);
          this.loading_survey_answers=false;
        }
      },
    )    
  }

  getCustomerRSByVisitUuid(id:any){
    this.visitService.getCustomerByVisit(id, ['id', 'customer', 'logo']);
    this.visitService.detailSubject.subscribe(
      ( data: any ) => {
        if(data.code =="9ee6b80261f5935fcdc9848ac558b605"){
          this.customer_fullName = data.visit.contact_fullName;
        }
      },
    )  
  }

  surveyStatus!:any;
  surveyStatusDisplay: string = '';
  getSurveyStatus(uuidVisit : any){
    this.msSurvey.getSurveyStatus(uuidVisit);
    this.msSurvey.surveyStatusSubject.subscribe(
      ( data: any ) => {
        if(data.status== '200'){
          this.surveyStatus = data.survey.surveyStatus;
          switch (this.surveyStatus) {
            case 'sent':
              this.surveyStatusDisplay = 'Envoyé';
              break;
            case 'consulted':
              this.surveyStatusDisplay = 'En attente';
              break;
            case 'responded':
              this.surveyStatusDisplay = 'Répondu';
              break;
            default:
              this.surveyStatusDisplay = '----';
              break;
          }
        }
      },
    )    
  }

  rolesSubscription!: Subscription;
  getProfileRoles(){
    var item:any =null;
    if(localStorage.getItem("prf")!=undefined) {
      item = localStorage.getItem("prf");
    }else if(sessionStorage.getItem("prf")!=undefined){
      item = sessionStorage.getItem("prf");
    }
    this.rolesSubscription = this.roleService.getProfileRoles(item).subscribe(
      (resp: any) => {
        if(resp.code == "bf025c4dcce776832c0d50903044d7f5") {
          this.storedRoles = resp.profileRoles;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  checkRole(roleName: string): Promise<boolean> {
    return new Promise((resolve) => {
      setTimeout(() => {
        const hasRole = this.storedRoles && this.storedRoles.some((role: any) => role.name === roleName);
        resolve(hasRole);
      }, 2000);
    });
  }

  // Function to get the sites for a specific city UUID
    getCitySites(cityUuid: string): string[] {
      const sites = this.visit?.visit_customer_Sites?.filter((site: any) => site.cityUuid === cityUuid);
      return sites.map((site: any) => site.siteName);
    }

    // Function to get the addresses for a specific city UUID
    getCityAddresses(cityUuid: string): string[] {
      const sites = this.visit?.visit_customer_Sites.filter((site: any) => site.cityUuid === cityUuid);
      return sites.map((site: any) => site.siteAddress);
    }

  // getTabActions(){
  //   this.loading_tab_actions=true;
  //   setTimeout(()=>{
  //     this.loading_tab_actions=false;
  //   }, 1000);
  //   // this.getActionsTabActions();
  // }  
  connectedCommercial:any="";
  today:any[]=[];allVisitsday:any []=[];
  TodayPlanning(){
    var globalvar = this;
    this.dashboardServiceservice.getToday();
    this.dashboardServiceservice.todaySubject.subscribe(
      ( data: any ) => {
        if(data.code =="e4b1ffed04086a59b097faa3afbf6197"){
          this.allVisitsday = data.visits;
          if(data.visits.length==0){
            setTimeout( function() {
              // create the notification
              var notification = new NotificationFx({
                  message : '<img src="assets/img/suivitim_img/calendar_white.gif" style="width: 50px;">'+
                  '<b>RAPPEL</b> : <br><p>Bonjour <b>'+globalvar.connectedCommercial+' </b><br> Aucune visite '+
                  'nˊest planifiée par vous pour aujourdˊhui ! <br>On vous invite à planifier de nouvelles visites <br><br>'+
                  '<img src="assets/img/suivitim_img/toright.gif" style="width: 25px;"><a href="planifier">  Planifier mes visite</a></p>',
                  layout : 'attached',
                  effect : 'bouncyflip',
                  type : 'notice', // notice, warning or error
                  onClose : function() {
                  }
              });
              // show the notification
              notification.show();
            }, 1200 );
          }
        }
      })
  }
  // getTabDetails(){
  //   this.loading_tab_details=true;
  //   setTimeout(()=>{
  //     // this.loading_tab_details=false;
  //   }, 2000);
  // }  
  resetForm(){
    this.updateActionForm.reset();
  }
  // getActionsTabActions(){
  //   this.loading_actions=true;
  //   setTimeout(()=>{
  //     // this.loading_actions=false;
  //   }, 1500);
  // }
  removeSelectedAction(list:any[],value:any){
    let index;
    if(value.action==undefined){
      index = list.findIndex(d => d=== value); //find index in your array
      list=this.actionsSelected;
    }else {
      index = list.findIndex(d => d.action=== value.action); //find index in your array
      list=this.actionsTeam;
    }
    list.splice(index, 1);//remove element from array
  }
  actionToEdit(action:any){
    this.actionEdit=action;
    this.newactionForm.setValue({
      action_label: this.actionEdit.action_label,
      action_type: this.actionEdit.action_type,
      //The x attribute should match the name in the API / database and not the name in your class
   });
    
  }
  ActionFormValue:any;action:any;
  newAction(){
    const ActionFormValue = this.newactionForm.value;
    this.action = {
      action :ActionFormValue.action,
      uuid:ActionFormValue.type
    };
    if(this.action.uuid=="perso"){
      this.actionsTeam.push(this.action);
    }
    setTimeout(()=>{
      this.newactionForm.reset();
    }, 1000);
    
  }
  detail_visit_action:any= {};
  getDetailVisit(visit:any){
    this.detail_visit_action = this.historyActions.find(i => i.uuid === visit);
  }
  contacted_persons:any;
  loading_detail:boolean=true;
  Detail(id:any){
    this.visitService.getDetail(id);
    this.visitService.detailSubject.subscribe(
      ( data: any ) => {
        if(data.code =="9ee6b80261f5935fcdc9848ac558b605"){
          this.visit= data.visit;
          this.msSector.getSector(this.token,this.visit.visit_customer_sector).subscribe(
            (sectorLabel: any) => {
              this.visit.visit_customer_sector = sectorLabel.label;
            },
            (error) => {
              console.log(error);
            }
          );
          this.perso= data.visit.actions;
          this.contacted_persons= data.visit.contacted_persons;
          this.today = data.visit.contacted_persons.slice(0, 0);
          this.CustumizedListactions(this.visit.visit_customer_uuid)
          if(data.visit.actions != null && data.visit.actions != undefined)
          this.actions= data.visit.actions.sort((a:any, b:any) => a.action_date - b.action_date);   
          // this.actions= data.actions;
          setTimeout(()=>{
            this.loading_tab_details=false;
            this.loading_detail=false;
            this.loading_actions=false;
            this.loading_tab_actions=false;
          }, 2000);
        }
      },
    )  
  }
  downloadPicture(event:any,visit:any,base:any){
    if(event.target != null){
      var datevisit = JSON.stringify(visit.visit_planned_at).slice(0,11)
      event.target!.setAttribute('href', 'data:image/jpg;base64,' + base);
      event.target!.setAttribute('download', 'visite_' +visit.visit_customer+"_"+visit.visited_by+"_"+datevisit+'.jpg');
    }
  }

  hoveredFile: any = null;

  showImage(file: any) {
      file.base64Image = 'data:image/png;base64,' + file.file;
      this.hoveredFile = file;
  }

  hideImage() {
      this.hoveredFile = null;
  }
    
  CustumizedListactions(id:any){
    this.visitService.getCustumizedactions(id);
    this.visitService.persoSubject.subscribe(
      ( data: any ) => {
        if(data.code =="ea6467a2de74bbe94af13a6ce4943968"){

          this.customizedActions= data.actions;
          this.customizedActions = this.customizedActions.sort((a:any, b:any) => a.action_label.toLowerCase() > b.action_label.toLowerCase() ? 1 : -1);
          this.addOrUpdateLoading = false;
        }
      },
    )  
  }
  addOrUpdateLoading:boolean = false;
  Newaction(){
    this.addOrUpdateLoading = true;
    var formvalues = this.newactionForm.value;
    if(this.newactionForm.valid){
      this.newactionRequest = {
        action_label :formvalues.action_label,
      }
      this.newactionServiceService.newactionRequest = this.newactionRequest;
      this.newactionServiceService.getNewaction();
      this.newactionServiceService.newactionSubject.subscribe(
      ( data: any ) => {
        if(data.code =="58e325bd14a8c619427cc77656e88a60"){
          this.action = {
            action :data.action.action_label,
            uuid:data.action.action_uuid,
          };
          this.actionsSelected.push(this.action.action);
          this.customizedActions.push(data.action);
          this.addOrUpdateLoading = false;
        }
        this.newactionForm.reset();
      },)
    }
  }
  getPublicActions(){
    this.visitService.getPublicActions();
    this.visitService.actionsSubject.subscribe(
      ( data: any ) => {
        if(data.code=="fc2057117571f77a7b4fdde71772ebcd"){
          this.publicActions = data.actions;
          this.publicActions = this.publicActions.sort((a:any, b:any) => a.action_label.toLowerCase() > b.action_label.toLowerCase() ? 1 : -1);
        }
      },
    )  
  }
  actiontype:any;
  Modifyaction(){
    this.actiontype="e183b47cb3af26aadf83cddda0d47453";
    this.addOrUpdateLoading = true;
    var formvalues = this.modifyactionForm.value;
    if(this.modifyactionForm.valid){
      this.modifyactionRequest = {
        action_label :formvalues.action_label,
        action_type:this.actiontype,
        customer:this.visit.visit_customer_uuid
      }
      this.modifyactionServiceService.modifyactionRequest = this.modifyactionRequest;
      this.modifyactionServiceService.getModifyaction(this.actionEdit.action_uuid);
      this.modifyactionServiceService.modifyactionSubject.subscribe(
      ( data: any ) => {  
        if(data.code =="4a7666e56245c35ffed4081a91ae730b"){
          this.action = {
            action :data.action.action_label,
            uuid:data.action.action_uuid,
          };
        }
        var index = this.customizedActions.indexOf(this.actionEdit);
        if (index !== -1) {
          this.CustumizedListactions(this.visit.visit_customer_uuid)
          
         }
         this.modifyactionForm.reset();
      },)
    }
  }
 
  getDetailrapport(history:any , visit:any){
    this.detailrapport = history ;
    this.visitdetail = visit ;
  }
  Deleteaction(id:any){
    this.addOrUpdateLoading = true;
    this.newactionServiceService.getDeleteaction(id);
    this.newactionServiceService.deleteactionSubject.subscribe(
      ( data: any ) => {
        if(data.code=="114c891a387eb63709491247e20afed3"){
          this.CustumizedListactions(this.visit.visit_customer_uuid)
        }this.addOrUpdateLoading = false;
      },
    )
  }
  getsupprimeraction(action:any){
    this.supprimeraction = action;
  }
  getAllCustomizedActions(){
    this.visitService.getAllCustomizedActions();
    this.visitService.customActionsSubject.subscribe(
      ( data: any ) => {
        if(data.code=="fc2057117571f77a7b4fdde71772ebcd"){
          this.customizedActions = data.actions;
          this.customizedActions = this.customizedActions.sort((a:any, b:any) => a.action_label.toLowerCase() > b.action_label.toLowerCase() ? 1 : -1);
        }
      },
    )  
  }
  pdfOrUpdateLoading:boolean = false;
  Pdf(id_visit:any){ 
    this.pdfOrUpdateLoading = true;
    this.dashboardServiceservice.getPdf(id_visit);
    this.dashboardServiceservice.pdfSubject.subscribe(
      ( data: any ) => {
        if(data.code =="f3030809fbd166bcc94653d58a6e6a47"){
          const source = `data:application/pdf;base64,`+data.report;
          const link = document.createElement("a");
          link.href = source;
          link.download = data.report_filename;
          link.click();
          this.pdfOrUpdateLoading = false;

          $("#successSave").show();
                $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#successSave").hide();
                }, 5000);
        }else{
          $("#error").show();
                $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#error").hide();
                }, 5000);
              }
      },)
  }
  loading_messages_visit:boolean=false;
  messages:any[]=[];
  getMessagesVisitTerminated(visit:any){
    this.messages = [];
    this.loading_messages_visit=true;
    this.dashboardServiceservice.getMessagesVisit(visit);
    this.dashboardServiceservice.getMessagesVisitSubject.subscribe(
      ( data: any ) => {
        this.loading_messages_visit=false;
        if(data.code=="d80c758c95256db1f67684948800447d") {
          this.messages = data.messagesVisit;
          // this.loading_messages_visit=false;
          setTimeout(() => {  
            $(".chat-messages")[0]?.animate({ scrollBottom: "320px" }, 200)
            var objDiv = $(".chat-messages")[0];
            objDiv.scrollTop = objDiv?.scrollHeight;
           }, 1000); 
        }else {
          this.messages = [];
        }
      },
    )
  }
  sending: boolean = false;
  sendNewMessage(visit:any){
    var message = $('#messageText').val();
    var myImage = null;
    var myavatar = this.messages.find((d:any) => d.sender== "me");
    if(myavatar!=undefined && myavatar!=null){
      myImage = myavatar.sender_avatar;
    }else {
      myImage = null;
    }            
    if(message != null && message != ""){
      this.sending = true;
      var newMessage = {
        message:message,
        sent_at:new Date(),
        sender:"me",
        sender_avatar:myImage,
        important:$("#roundedChk2").is(':checked')
      }
      var requestBody = {
        message:message,
        important:$("#roundedChk2").is(':checked')
      }
      this.dashboardServiceservice.requestResponseVisit = requestBody;
      this.dashboardServiceservice.sendResponseVisit(visit);
      this.dashboardServiceservice.sendResponseVisitSubject.subscribe(
        ( data: any ) => {
          this.loading_messages_visit=false;
          if(data.code=="292d9f0775864378afb843227b9209b5") {
            this.messages.push(newMessage);
            // $(".chat-messages").animate({scrollTop:$(".chat-messages")[0].scrollHeight})
            $(".chat-messages").animate({ scrollTop: $(".chat-messages")[0]?.scrollHeight }, 500)
            $('#messageText').val("");
            $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0]?.scrollHeight }, 200)
          }
          this.sending = false;
        },)
    }
    
  }
  MarkAsRead(visit:any){
    this.dashboardServiceservice.markAsRead(visit, null);
    this.dashboardServiceservice.markAsReadSubject.subscribe(
      ( data: any ) => {
    })
  } 

  selectedAction:any ={};
  selectAction(action:any){    
    this.selectedAction = null;
    this.selectedAction = this.actions.find((d:any) => d.action == action);      
    this.updateActionForm.patchValue({
      description:this.selectedAction.action_desc?this.selectedAction.action_desc:'---',
      status:this.getStatus(this.selectedAction.action_status),
      motif :this.selectedAction.action_comment?this.selectedAction.action_comment:''
    })
  }

  getStatus(status: string): string {
    switch (status) {
      case 'Non fait':
        return '38515baefec364fd3d5cf3efb177fa79';
      case 'En cours':
        return '35377d896b4b5dfbe7e5cd804a58ecdb';
      case 'Fait':
        return 'done';
    
      default:
        return '';
    }
  }
  getNameOfStatus(status: string):string{
    switch (status) {
      case '38515baefec364fd3d5cf3efb177fa79':
        return 'Non fait';
      case '35377d896b4b5dfbe7e5cd804a58ecdb':
        return 'En cours';
      case 'done':
        return 'Fait';
    
      default:
        return '';
    }
  }

  successUpdateAction:boolean=false;
  failedUpdateAction:boolean=false;
  loaderUpdateAction:boolean=false;
  updateActionStatusSubscription!: Subscription;

  updateActionStatus(){
    this.loaderUpdateAction = true;
    let formValue = this.updateActionForm.value;
    this.updateActionStatusSubscription = this.visitService.updateStatusAction(formValue.status,formValue.motif,this.selectedAction.action,this.visit.visit).subscribe(
      ( data: any ) => {
        if(data.code=="5f116e45b722b38a15b57085f5705011"){
          this.successUpdateAction = true;
          this.failedUpdateAction = false;
          this.selectedAction.action_status = this.getNameOfStatus(formValue.status);
          this.selectedAction.action_comment = this.updateActionForm.get('motif')?.value;
          const i=this.actions.findIndex((d:any) => d.action == this.selectedAction.action);
          if(i) this.actions.splice(i,1,this.selectedAction);
          this.updateActionForm.reset()

          $("#status_action_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          this.loaderUpdateAction=false;
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#status_action_updated").hide();
            $("#updateAction").click();
          }, 8000);
        }else {
          this.loaderUpdateAction=false;
          this.successUpdateAction = false;
          this.failedUpdateAction = true;
          $("#status_action_not_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#status_action_not_updated").hide();
          }, 8000);
        }
      },
      (err: any) => {
        console.log(err);
        this.loaderUpdateAction=false
        
      }
    )  
  }
  getVisitCities(): string {
    if (!this.visit || !this.visit.visit_customer_cities || this.visit.visit_customer_cities.length === 0) {
      return '---';
    }

    return this.visit.visit_customer_cities.map((city:any) => city.name).join(' - ');
  }

  ngOnDestroy(){
    this.updateActionStatusSubscription?.unsubscribe();
  }
}
